import * as XLSX from "xlsx";

/**
 * This function download the table in excel.
 */
export const exportexcel = (ref, name = "ExcelSheet") => {
  // let element = document.getElementById("userInputInfo");
  const ws = XLSX.utils.table_to_sheet(ref);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  XLSX.writeFile(wb, name + ".xlsx");
};

/**
 * This function download the data in excel.
 */
export const exportDatatoExcel = (data, name = "data.xlsx") => {
  // const ws = XLSX.utils.table_to_sheet(partsRef.current);
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  const excelBuffer = XLSX.write(wb, { type: "buffer", bookType: "xlsx" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const downloadLink = document.createElement("a");
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = name;
  downloadLink.click();
};

/**
 * this function conver the json data of graph in the excel file, and download it.
 */
export const downloadExcelFromLink = (apiUrl, fileName) => {
  // Create a download link and trigger the download
  const url = apiUrl; //URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();

  //cleanup
  URL.revokeObjectURL(url);
  document.body.removeChild(link);
};
